<template>
    <spinner-until :condition="participantLoaded">
        <participant-menu>
            <div class="my-goals">
                <b-row>
                    <b-col cols="12" lg="6" ref="goals">
                        <b-card no-body class="card__tables">
                            <b-card-header v-if="!showParticipantMenuAsAccordion">
                                <h5>
                                <span class="icon-wrapper icon-wrapper-left">
                                    <shs-icon name="flag"></shs-icon>
                                </span>
                                    {{ $i18n.gt('HEADING_MY_GOALS') }}
                                    <print-button content="goals" :refs="$refs"/>
                                </h5>
                            </b-card-header>
                            <b-card-body>
                                <table class="table card-table">
                                    <tbody>
                                    <tr v-for="(g, index) in goals" :key="index">
                                        <td class="font-weight-bold">{{ g.timeframe }}</td>
                                        <td>{{ g.goal }}</td>
                                        <td>
                                            <my-goals-edit-modal :goals="goals"
                                                                 :goal="g"
                                                                 :index="index">
                                            </my-goals-edit-modal>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </b-card-body>
                            <b-card-footer class="text-center">
                                <my-goals-edit-modal :goals="goals">
                                </my-goals-edit-modal>
                            </b-card-footer>
                        </b-card>
                    </b-col>
                    <b-col cols="12" lg="6"
                           ref="progress-notes"
                           v-if="showLastNote">
                        <b-card no-body>
                            <b-card-header>
                                <h5>
                                    {{ $i18n.gt('HEADING_PROGRESS_NOTES') }}
                                    <print-button content="progress-notes" :refs="$refs"/>
                                </h5>
                            </b-card-header>
                            <b-card-body>
                                <survey-note-list :participantId="participant.id"
                                                  :for-patient="true">
                                </survey-note-list>
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </participant-menu>
    </spinner-until>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'
import * as _ from 'lodash'
import PatientPageMixin from '@/providers/PatientPageMixin'

import GoalFields from '@/models/Goal'

/**
 * Page to manage a Participant's wellness goals
 */
export default Vue.extend({
    name: 'MyGoals',
    mixins: [PatientPageMixin],
    data() {
        return {
            selectedGoal: {
                goal: null,
                timeframe: null
            },
            goalFields: GoalFields,
            fieldGroups: [['goal', 'timeframe']],

        }
    },
    computed: {
        goals() {
            return this.participant.wellness_plan.goals
        },
        showLastNote() {
            return !this.$user.practitionerId()
        },
    },
})
</script>

<style lang="scss">
.my-goals {
    .print-button {
        float: right;
        margin-top: .2em;
    }
}
</style>
